var map = {
	"./1.png": 2366,
	"./POIgeneric.jpg": 2367,
	"./cmentarz.jpg": 2368,
	"./hotel.jpg": 2369,
	"./kosciol.jpg": 2370,
	"./kultura.jpg": 2371,
	"./map-icon.png": 2372,
	"./przyroda.jpg": 2373,
	"./rekreacja.jpg": 2374,
	"./schronisko.jpg": 2375,
	"./swieczki.jpg": 2361,
	"./szkola.jpg": 2376,
	"./transport.jpg": 2377,
	"./x.png": 2359,
	"./zabytek.jpg": 2378
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2365;



//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img ^\.\/.*$
// module id = 2365
// module chunks = 0